
































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { studentModule } from '@/store/modules/entities/student.module';
import { Student } from '@/models/student/student';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import { CompetencyGrowthEchartService } from '@/service/echart/competency-growth.echart.service';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GLoading from '@/components/GLoading.vue';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GStudentAllCompetencyFunChart',
  components: { GLoading, GCustomBreadCrumb, GCompetencyLabel },
  computed: {},
  methods: {},
})
export default class GStudentAllCompetencyFunChart extends Mixins(GPageBase) {
  studentID: number = 0;
  competencyGrowthCharts: CompetencyGrowthEchartService[] = [];
  readonly CHART_HEIGHT = 240;

  created() {
    this.studentID = parseInt(this.$route.params.studentID);
  }
  async mounted() {
    this.competencyGrowthCharts = this.studentCompetencyGrowth.map((studentCompetencyGrowth: StudentCompetencyGrowth) => new CompetencyGrowthEchartService(studentCompetencyGrowth));
    this.competencyGrowthCharts = this.competencyGrowthCharts.map((service: CompetencyGrowthEchartService) => {
      service.isFunchart = true;
      return service;
    });
  }

  get optionsMap(): Map<number, any> {
    const optionsMap = new Map<number, any>();
    this.competencyGrowthCharts.map((c: CompetencyGrowthEchartService) => {
      this.conversionFanchart(c.options);
      optionsMap.set(c.studentCompetencyGrowth.competencyID, c.options);
    });
    return null;
  }

  conversionFanchart(options: any) {
    if (options) {
      options.series.map((s: any) => {
        let firstScore: number = 0;
        if (s.data.length > 0) s.data[0] <= 0 ? (firstScore = 1) : (firstScore = s.data[0]);
        s.data = s.data.map((d: any) => {
          const score = Math.floor((d / firstScore) * 100 * 10) / 10;
          return score;
        });
      });
    }
  }

  get student(): Student {
    return studentModule.student;
  }

  get competencyIDs(): number[] {
    return Constants.CompetencyIDsBySortedType;
  }

  get studentCompetencyGrowth(): StudentCompetencyGrowth[] {
    return studentAllCompetencyModule.studentCompetencyGrowth;
  }
}
